(function(){
  var root=document.querySelector('.hx-meta .hx-block__media');
  if(!root)return;
  var img=root.querySelector('img');
  if(!img)return;
  var mq=window.matchMedia('(min-width:860px)');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking=false;
  function update(){
    ticking=false;
    if(reduce||!mq.matches){img.style.transform='';return;}
    var r=root.getBoundingClientRect();
    var vh=window.innerHeight||document.documentElement.clientHeight;
    var p=(vh-r.top)/(vh+r.height);
    if(p<0)p=0;else if(p>1)p=1;
    var shift=-(p*30);
    img.style.transform='translate3d('+shift.toFixed(2)+'%,0,0)';
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  update();
})();
